import React from 'react'
import { styled } from 'src/ui/theme'
import { breakpoints } from 'src/ui/dimensions'
import { TRewardCellData } from '../../atoms/reward-cell/types'
import { RewardCell } from '../../atoms'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 0;

  @media (max-width: ${breakpoints.mobile}px) {
    width: calc(100% - 32px);
    display: grid;
    grid-template-columns: repeat(2, auto);
    column-gap: 8px;
    row-gap: 24px;
  }
`

type Props = {
  items: TRewardCellData[]
}

export const RewardRow: React.FC<Props> = ({ items }) => {
  return (
    <Wrapper>
      {items.map((item, index) => (
        <RewardCell rewardData={item} key={index} />
      ))}
    </Wrapper>
  )
}
